<div class="card">
  <div class="strip" (click)="onManageProgram()">
    <ion-icon name="accessibility-outline" />
    <div>Weight Loss Program</div>
    <ion-icon name="arrow-forward-outline" />
  </div>
  <div class="head">
    <div>
      <div class="title">{{ this.program().medication }}</div>
    </div>
    <div class="program-detail first">
      <div>Next payment due</div>
      <div class="program-detail-value"> {{ formattedDate() }} </div>
    </div>
    <div class="program-detail">
      <div>To</div>
      <div class="program-detail-value"> {{ formattedAddress() }} </div>
    </div>
  </div>
  @if (paymentError()) {
    <div class="payment-error">
      <ion-icon name="warning" />
      <div>
        Payment declined.
        <a (click)="onManageProgram()">Please check your payment details</a>
      </div>
    </div>
  }
</div>
